import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PageHeader  from '../components/ui/PageHeader';
import StatCard    from '../components/ui/StatCard';
import Card        from '../components/ui/Card';
import Badge       from '../components/ui/Badge';
import DataTable   from '../components/ui/DataTable';
import useAuth from '../hooks/useAuth';
import { useSeason } from '../context/SeasonContext';
import { FiRefreshCw } from 'react-icons/fi';

const COLUMNS = [
  { key: 'material', label: 'Material',     render: (v) => <strong style={{ color: 'var(--text)' }}>{v}</strong> },
  { key: 'opening',  label: 'Opening',      render: (v) => <span style={{ fontFamily: 'var(--font-mono)' }}>{v}</span> },
  { key: 'received', label: 'Received',     render: (v) => <span style={{ fontFamily: 'var(--font-mono)', color: 'var(--accent)' }}>{v}</span> },
  { key: 'issued',   label: 'Issued',       render: (v) => <span style={{ fontFamily: 'var(--font-mono)', color: 'var(--gold)' }}>{v}</span> },
  { key: 'closing',  label: 'Closing',      render: (v) => <strong style={{ fontFamily: 'var(--font-mono)', color: 'var(--text)' }}>{v}</strong> },
  { key: 'unit',     label: 'Unit'          },
  { key: 'stage',    label: 'Stage',        render: (v, row) => <Badge color={row.color}>{v}</Badge> },
];

export default function Inventory() {
  const token = sessionStorage.getItem("maaze_token");
  const { refreshToken } = useAuth();
  const API = "https://maize.norissolutions.in/Php/public/api";

  const [cards, setCards] = useState({
    raw_material: 0,
    distributed: 0,
    collected: 0,
    in_factory: 0,
    dried_stock: 0,
    finished_goods: 0,
  });

  const [stockSummary, setStockSummary] = useState([]);

  useEffect(() => {
    const fetchInventory = async () => {
      try {
        const headers = { Authorization: `Bearer ${token}` };
        const [cardsRes, summaryRes] = await Promise.all([
          axios.get(`${API}/inventory`, { headers }),
          axios.get(`${API}/inventory/stock-summary`, { headers }),
        ]);

        if (cardsRes.data?.data) {
          setCards(cardsRes.data.data);
        }

        if (summaryRes.data?.data) {
          const mapped = summaryRes.data.data.map(item => {
             let color = 'gray';
             if (item.stage === 'Raw' || item.stage === 'Processing') color = 'gold';
             else if (item.stage === 'Distributed' || item.stage === 'Ready') color = 'sky';
             else if (item.stage === 'Collected' || item.stage === 'Final') color = 'green';
             
             return { ...item, color };
          });
          setStockSummary(mapped);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchInventory();
  }, [token]);

  return (
    <div>
      <PageHeader title="Inventory" subtitle="Real-time stock levels across all production stages">
        <FiRefreshCw className="page-refresh" onClick={refreshToken} />
      </PageHeader>

      <div className="stats-grid mb-24">
        <StatCard label="Raw Material"   value={cards.raw_material}  unit="kg" icon="🌾" />
        <StatCard label="Distributed"   value={cards.distributed}  unit="kg" icon="🚚" variant="sky" />
        <StatCard label="Collected"     value={cards.collected}  unit="kg" icon="📦" variant="gold" />
        <StatCard label="In Factory"    value={cards.in_factory}  unit="kg" icon="🏭" />
        <StatCard label="Dried Stock"   value={cards.dried_stock}  unit="kg" icon="☀️" variant="sky" />
        <StatCard label="Finished Goods" value={cards.finished_goods} unit="kg" icon="📫" variant="gold" />
      </div>

      <Card title="Stock Level Summary" subtitle="All material types" noPad>
        <DataTable columns={COLUMNS} rows={stockSummary} />
      </Card>
    </div>
  );
}
